import React, { useState, useEffect, useContext } from "react";
import {
    Toolbar,
    Grid,
    Box,
    Avatar,
    IconButton,
    Badge,
    Tooltip,
    Button,
    Icon,
    TextField,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import logo from "../../assets/images/logo.png";
// import independence_day_pricing from "../../assets/images/independence_day.jpeg"
import independence_day_pricing from "../../assets/images/diwali_offer_button.jpeg"
import { APPDrawer } from "./drawer";
import { stringAvatar } from "../../common/utility/helperFunc";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RupeeIcon from "@mui/icons-material/CurrencyRupee";
import HelpIcon from "@mui/icons-material/Article";
import InfoIcon from "@mui/icons-material/Info";
import BookmarkIcon from "@mui/icons-material/Bookmarks";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useAxios } from "../../common/api/hooks/useAxios";
import { clearLoginResults } from "../../common/utility/browserLoginCoordinator";
import { notifySameUserLoggedOut } from "../../common/api/hooks/useAxiosPrivate";
import { URL } from "../../common/api/urls";
import {
    TEXT_MSGS,
    SNACKBAR_AUTO_HIDE_DURATION,
    USER_ROLE_FIELDS,
    USER_RESOURCES_LIST,
    DEMO_POPUP_TYPES,
} from "../../common/utility/constant";
import { Snackbar, Alert } from "@mui/material";
import useAuth from "../../common/hooks/useAuth";
// ============================================================
// NEW - Centralized Permission Service
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from "../../common/hooks/usePermissions";
import SubscriptionPopup from "../../pages/dashboard/components/subscription_popup";
import { BOOKMARK_COMP } from "../../common/utility/configData";
import useMediaQuery from "@mui/material/useMediaQuery";
import UserManualNewPopup from "../../pages/dashboard/components/user_manual_new_pop_up";
import ToolsWalkthroughPopup from "../../pages/dashboard/components/tools_walkthrough_pop_up";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import FAQPopup from "../../pages/dashboard/components/faq_pop_up";
import BrokerPopup from "../../pages/dashboard/components/broker_popup";
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth";
import BookmarkComponent from "./BookmarkComponent";
import EcoursePopup from "../../pages/dashboard/components/ecourse_popup";
import UpgradePopup from "../../pages/dashboard/components/upgrade_popup";
import NotificationComponent from "./NotificationComponent";
import GlossaryPopup from "../../pages/dashboard/components/glossary_pop_up";
import DemoConfirmationPopup from "../../pages/dashboard/components/of_demo_confirm_popup";
import AppErrorPopup from "../AppErrorPopup";
import DemoIcon from "@mui/icons-material/OndemandVideo";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import { UserSettingsContext } from "../../setup/routes-manager/RequireAuth";


// Shared button style — every header button uses this exact same shape
// Shared button style — optimized for large, prominent icons
const HEADER_BTN_SX = {
    height: "38px",
    minWidth: 0,
    px: 1.5,
    fontSize: "1rem",
    fontWeight: 500,
    whiteSpace: "nowrap",
    flexShrink: 0,
    textTransform: "none",
    gap: "8px",
    borderRadius: "6px",

    color: "#FFFFFF",
    backgroundColor: "#315ED8",

   
};

const HeaderToolbar = styled(Toolbar)(
    ({ theme, coachActive }) => `
        background-color:${theme.palette.primaryTheme.shade07};
        width:100%;
        height:48px;
        min-height:48px !important;   /* <-- add this */
        position:fixed;
        z-index:${coachActive ? 1601 : 999};
        box-sizing:border-box;
        padding:0 16px !important;
    `,
);

const DashboardHeader = (props) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const { cancel, responseData, error, loaded, reset, executeAPI } =
        useAxios();
    const [showPopup, setShowPopup] = useState(false);
    const [showProPopup, setShowProPopup] = useState(false);
    const matches = true; //useMediaQuery("(min-width:640px)");
    const isLargeScreen = useMediaQuery("(min-width:1600px)");
    const [subscriptionPopupData, setSubscriptionPopupData] = useState({
        isCustom: false,
        msg: "",
    });
    const [showUserManualNewPopup, setShowUserManualNewPopup] = useState(false);
    const { showMPChartWalkthrough, showOFWalkthroughCoach, setShowMPChartWalkthrough, showGlossaryPopup: openGlossaryFromContext, setShowGlossaryPopup: setOpenGlossaryFromContext } =
        useContext(UserSettingsContext);
    // const [showDemoPopup, setShowDemoPopup] = useState(false);
    const [showFaqPopup, setShowFaqPopup] = useState(false);
    const [showGlossaryPopup, setShowGlossaryPopup] = useState(false);
    const [showBrokerPopup, setShowBrokerPopup] = useState(false);
    const [showECoursePopup, setShowECoursePopup] = useState(false);
    const [showUpgradePopup, setShowUpgradePopup] = useState(false);
    const [showDemoConfirmPopup, setShowDemoConfirmPopup] = useState(false);
    const [msgState, setMsgState] = useState({
        open: false,
        msg: "",
        severity: "info",
    });
    const { open, msg, severity } = msgState;
    const { auth, setAuth, setPersist } = useAuth();
    const permissions = usePermissions();
    const isPro2User = permissions.isPro2User();
    const hasNotificationAccess = permissions.hasPushNotificationAccess();
    const from = "/login";
    const isToolsCoachActive = showOFWalkthroughCoach;

    const getHeaderButtonSx = (isTarget = false) => ({
        ...HEADER_BTN_SX,
        opacity: 1,
        transition: "filter 180ms ease, opacity 180ms ease",
        filter:
            isToolsCoachActive && !isTarget
                ? "blur(1.5px) brightness(0.82)"
                : "none",
    });
    const [
        cancelBookmark,
        responseDataBookmark,
        errorBookmark,
        loadedBookmark,
        resetBookmark,
        executeAPIBookmark,
    ] = useAxiosWithAuth();
    const [
        cancelSubscription,
        responseDataSubcription,
        errorSubscription,
        loadedSubscription,
        resetSubscription,
        executeAPISubscription,
    ] = useAxiosWithAuth();
    const isEliteUser = permissions.isEliteUser();
    const [bookmarkList, setBookmarkList] = useState([]);
    const isEcourseBought = permissions.hasResource(
        USER_RESOURCES_LIST.E_COURSE,
    );
    const [subscriptionData, setSubscriptionData] = useState();
    const isDemoCompleted = auth?.demo;
    const demoType = { demoType: DEMO_POPUP_TYPES.NEW_USER };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        executeAPISubscription(URL.USER_SUBSCRIPTION, "GET", {});
        if (isEliteUser) {
            executeAPIBookmark(URL.GET_ALL_GLOBAL_BOOKMARK, "GET", {});
        }
    }, []);

    //api response handler
    useEffect(() => {
        if (loadedBookmark) {
            if (responseDataBookmark != null) {
                let data = responseDataBookmark.data
                    ? responseDataBookmark.data
                    : [];
                setBookmarkList(data);
            } else if (errorBookmark !== null) {
                if (
                    errorBookmark?.response?.status === 401 ||
                    errorBookmark?.response?.status === 403
                ) {
                    navigate(from, { replace: true });
                } else {
                    setMsgState({
                        open: true,
                        msg:
                            errorBookmark?.response?.data?.message ??
                            `${TEXT_MSGS.NETWORK_ERROR_MSG}`,
                        severity: "error",
                    });
                }
            }
            resetBookmark();
        }
    }, [loadedBookmark, responseDataBookmark]);

    /**
     * API response handler subscription data
     */
    useEffect(() => {
        if (loadedSubscription) {
            if (responseDataSubcription != null) {
                setSubscriptionData(responseDataSubcription.data);
            } else if (errorSubscription !== null) {
                setMsgState({
                    open: true,
                    msg:
                        errorSubscription?.response?.data?.message ??
                        `${TEXT_MSGS.NETWORK_ERROR_MSG}`,
                    severity: "error",
                });
                if (
                    errorSubscription?.response?.status === 401 ||
                    errorSubscription?.response?.status === 403
                ) {
                    navigate(from, { replace: true });
                }
            }
            resetSubscription();
        }
    }, [loadedSubscription, responseDataSubcription]);

    /**
     * API response handler
     */
    useEffect(() => {
        if (loaded) {
            if (responseData != null) {
                navigate("/login", { replace: true });
            } else if (error !== null) {
                setMsgState({
                    open: true,
                    msg:
                        error?.response?.data?.message ??
                        `${TEXT_MSGS.NETWORK_ERROR_MSG}`,
                    severity: "error",
                });
                reset();
            }
        }
    }, [loaded, responseData, error, navigate]);

    const setSelection = (route, component) => {
        props.setCurrentRoute(route, component);
    };
    const openGlossary = () => {
        setShowGlossaryPopup(true);
    };
    const openDemoConfirmPopup = () => {
        setShowDemoConfirmPopup(true);
    };
    const openUserManualNew = () => {
    // navigate('/user-manual', { replace: true });
    // setShowDemoPopup(false);

      setShowUserManualNewPopup(true);
    };

    useEffect(() => {
        if (showMPChartWalkthrough) {
            setShowUserManualNewPopup(true);
            setShowMPChartWalkthrough(false);
        }
    }, [showMPChartWalkthrough, setShowMPChartWalkthrough]);

    useEffect(() => {
        if (openGlossaryFromContext) {
            setShowGlossaryPopup(true);
            setOpenGlossaryFromContext(false);
        }
    }, [openGlossaryFromContext, setOpenGlossaryFromContext]);
    // const openDemoPopup = () => {
    //   // setShowUserManualPopup(false); 
    //   setShowDemoPopup(true);
    // };

    const openGlobalBookmark = () => {
        if (!isEliteUser) {
            setSubscriptionPopupData({
                isCustom: true,
                msg: TEXT_MSGS.ELITE_UPGRADE_MSG,
            });
            setShowProPopup(true);
        } else {
            navigate("/global-bookmarks", { replace: true });
        }
    };

    const openProfile = () => {
        setAnchorEl(null);
        navigate("/profile", { replace: false });
    };

    const handleLogout = () => {
        setAnchorEl(null);
        notifySameUserLoggedOut(auth?.email_id);
        clearLoginResults();
        setAuth({});
        setPersist(false);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userSettings");
        localStorage.removeItem("UIData");
        localStorage.removeItem("bookmark_category");
        localStorage.removeItem("bookmark_list");
        localStorage.removeItem("auto_saved_links");
        localStorage.removeItem("hasUnreadNotifications");
        localStorage.removeItem("upgrade_msg_index");
        localStorage.removeItem("persist");
        executeAPI(URL.LOGOUT, "POST", null);
        navigate("/landing", { replace: true });
        setTimeout(() => {
            window.location.replace("/landing");
        }, 100);
    };

    const showSubscribeModal = () => {
        setShowPopup(true);
    };

    const showSubscribeProModal = (isCustom = false, msg) => {
        setSubscriptionPopupData(
            isCustom ? { isCustom: true, msg } : { isCustom: false, msg: "" },
        );
        setShowProPopup(true);
    };

    const showBrokerLoginPopup = () => {
        setShowBrokerPopup(true);
    };
    const handleBookmarkClick = (bookmark) => {
    //     // console.log("Clicked on:", bookmark);
    };
    const handleNotificationClick = (item) => {
    //     // console.log("Clicked on:", item);
    };
    const openECoursePopup = () => {
        setShowECoursePopup(true);
    };
    const handleConfirm = () => {
        setShowECoursePopup(false);
    };
    const openUpgradePopup = () => {
        setShowUpgradePopup(true);
    };
    const handleOpenSubscription = () => {
        setShowUpgradePopup(false);
        navigate("/subscription");
    };

    return (
        <div>
            <HeaderToolbar coachActive={showOFWalkthroughCoach || showMPChartWalkthrough}>
                {/* Swapped Grid for a high-performance fluid Flexbox Box */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        position:"relative"
                    }}
                >
                    {/* Left Block Elements Container */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexShrink: 0,
                    
                        }}
                    >
                        <APPDrawer
                            onChange={setSelection}
                            isEcourseBought={isEcourseBought}
                            subscriptionData={subscriptionData}
                            openBrokerModal={showBrokerLoginPopup}
                            openECoursePopup={openECoursePopup}
                            openUpgradePopup={openUpgradePopup}
                            openSubscribeModal={showSubscribeModal}
                            openSubscribeProModal={showSubscribeProModal}
                            openToolsWalkthrough={props.openToolsWalkthrough}  
                        />
                       <Box
                            component="button"
                            type="button"
                            onClick={() => navigate("/pricing")}
                            aria-label="View Independence Day Sale pricing"
                            sx={{
                                ml: 1.5,
                                height: "46px",
                                width: "360px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                flexShrink: 0,
                                overflow: "hidden",
                                borderRadius: "10px",
                                border: "1px solid rgba(255, 255, 255, 0.18)",
                                background: "transparent",
                                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.4)",
                                cursor: "pointer",
                                transition: "transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease",
                                "&:hover": {
                                    transform: "scale(1.02)",
                                    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.45)",
                                    filter: "brightness(1.03)",
                                },
                                "&:active": {
                                    transform: "scale(0.99)",
                                },
                            }}
                        >
                            <img
                                src={independence_day_pricing}
                                alt="Independence Day Sale"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill",
                                    display: "block",
                                    borderRadius: "9px",
                                }}
                            />
                            </Box>
                        {props.headerData && matches ? (
                            <Tooltip title={props.headerData.name}>
                                <Typography
                                    sx={{
                                        color: "primaryTheme.shade01",
                                        fontSize: "20px",
                                        ml: 2,
                                        fontWeight: 700,
                                        maxWidth: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    <u>{props.headerData.name}</u>
                                </Typography>
                            </Tooltip>
                        ) : null}
                    </Box>

                {/* Center block — logo always centers in whatever space remains
                    between left and right blocks, regardless of their width */}
	          {matches && (
                    <Box
                        component="button"
                        type="button"
                        sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "36px",
                            width: "auto",
                            padding: 0,
                            border: 0,
                            background: "transparent",
                            cursor: "pointer",

                            "&:hover": {
                                transform: "translateX(-50%) scale(1.05)",
                                filter: "drop-shadow(0 2px 6px rgba(255, 255, 255, 0.22)) brightness(1.04)",
                            },

                            "&:active": {
                                transform: "translateX(-50%) scale(0.98)",
                            },
                        }}
                        onClick={() => navigate("/auth-landing")}
                        aria-label="Go to Vtrender home"
                    >
                        <img
                            src={logo}
                            alt="Vtrender Logo"
                            style={{
                                height: "32px",
                                width: "auto",
                                objectFit: "contain",
                                display: "block",
                            }}
                        />
                    </Box>
                )}
                    {/* Right Action Items Array Wrapper */}
                    <Box
                        sx={{
                            marginLeft:"auto",
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            // flexShrink: 0,
                        }}
                    >
                        {/* Desktop Actions Row (Hides safely below 1400px viewports) */}
                        {isLargeScreen && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.4,
                                }}
                            >
                                {/* May Reset Action */}
                                {/* <Button
                                    variant="contained"
                                    href="/auth-may-reset"
                                    sx={{
                                        ...HEADER_BTN_SX,
                                        color: "#ffffff",
                                        background:
                                            "linear-gradient(120deg, #edb893, #93566b, #9d5614, #9e679d)",
                                        backgroundSize: "240% 240%",
                                        border: "1px solid rgba(110, 231, 199, 0.6)",
                                        animation:
                                            "offerGradientMove 4s ease infinite, offerGlowPulse 2.2s ease-in-out infinite",
                                        "@keyframes offerGradientMove": {
                                            "0%": {
                                                backgroundPosition: "0% 50%",
                                            },
                                            "50%": {
                                                backgroundPosition: "100% 50%",
                                            },
                                            "100%": {
                                                backgroundPosition: "0% 50%",
                                            },
                                        },
                                        "@keyframes offerGlowPulse": {
                                            "0%, 100%": {
                                                boxShadow:
                                                    "0 2px 12px rgba(110, 231, 199, 0.22)",
                                            },
                                            "50%": {
                                                boxShadow:
                                                    "0 4px 18px rgba(167, 139, 250, 0.32)",
                                            },
                                        },
                                        "&:hover": {
                                            filter: "brightness(1.1)",
                                            background:
                                                "linear-gradient(120deg, #edb893, #93566b, #9d5614, #9e679d)",
                                        },
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "inherit",
                                            whiteSpace: "nowrap",
                                            marginRight: "4px",
                                        }}
                                    >
                                        May Reset
                                    </span> */}
                                    {/* <LocalOfferIcon
                                        sx={{
                                            width: "14px",
                                            height: "14px",
                                            color: "#ffffff",
                                            flexShrink: 0,
                                        }}
                                    />
                                </Button> */}

                                {/* Pricing Action */}
                                <Button
                                        variant="contained"
                                        href="/subscription"
                                    sx={getHeaderButtonSx()}
                                    >
                                        <span style={{ fontSize: "inherit", whiteSpace: "nowrap" }}>
                                            Pricing
                                        </span>
                                        <RupeeIcon
                                            sx={{
                                                width: "25px",  // ◄ Massive, highly noticeable icon size
                                                height: "25px",
                                                flexShrink: 0,
                                            }}
                                        />
                                    </Button>
                                    {/* Tools Walkthrough Action */}
                                <Button
                                        id="vtrender-open-walkthrough-btn"
                                    variant="contained"
                                    onClick={props.openToolsWalkthrough}
                                    sx={getHeaderButtonSx(true)}
                                >
                                    <span
                                        style={{
                                            fontSize: "inherit",
                                            whiteSpace: "nowrap",
                                            marginRight: "4px",
                                        }}
                                    >
                                        Tools Walkthrough
                                    </span>
                                    <AutoStoriesOutlinedIcon
                                        sx={{
                                            width: "25px",
                                            height: "25px",
                                            flexShrink: 0,
                                        }}
                                    />
                                </Button>

                                {/* User Manual Action */}
                                <Button
                                    id="vtrender-user-manual-btn"
                                    variant="contained"
                                    onClick={openUserManualNew}
                                    sx={getHeaderButtonSx()}
                                >
                                    <span
                                        style={{
                                            fontSize: "inherit",
                                            whiteSpace: "nowrap",
                                            marginRight: "4px",
                                        }}
                                    >
                                        User Manual
                                    </span>
                                    <HelpIcon
                                        sx={{
                                            width: "25px",
                                            height: "25px",
                                            flexShrink: 0,
                                        }}
                                    />
                                </Button>

                                {/* Glossary Action */}
                                <Button
                                    id="vtrender-glossary-btn"
                                    variant="contained"
                                    onClick={openGlossary}
                                    sx={getHeaderButtonSx()}
                                >
                                    <span
                                        style={{
                                            fontSize: "inherit",
                                            whiteSpace: "nowrap",
                                            marginRight: "4px",
                                        }}
                                    >
                                        Glossary
                                    </span>
                                    <InfoIcon
                                        sx={{
                                            width: "25px",
                                            height: "25px",
                                            flexShrink: 0,
                                        }}
                                    />
                                </Button>

                                {/* Elite Demo Action */}
                                {!isDemoCompleted && (
                                    <Button
                                        variant="contained"
                                        onClick={openDemoConfirmPopup}
                                        sx={getHeaderButtonSx()}
                                    >
                                        <span
                                            style={{
                                                fontSize: "inherit",
                                                whiteSpace: "nowrap",
                                                marginRight: "4px",
                                            }}
                                        >
                                            Elite Demo
                                        </span>
                                        <DemoIcon
                                            sx={{
                                                width: "25px",
                                                height: "25px",
                                                flexShrink: 0,
                                            }}
                                        />
                                    </Button>
                                )}
                            </Box>
                        )}

                        {/* Global Utilities Tray */}
                        <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                            <BookmarkComponent
                                bookmarks={bookmarkList}
                                onBookmarkClick={handleBookmarkClick}
                            />

                            {matches && hasNotificationAccess && (
                                <NotificationComponent
                                    onNoticationClick={handleNotificationClick}
                                />
                            )}

                            <Avatar
                                id="basic-button"
                                aria-controls={
                                    openMenu ? "basic-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={openMenu ? "true" : undefined}
                                onClick={handleClick}
                                sx={{ cursor: "pointer" }}
                                {...stringAvatar(auth.name)}
                            />
                        </Box>
                    </Box>
                </Box>
            </HeaderToolbar>

            {/* Dropdown Menu Systems */}
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                sx={{ minWidth: "140px" }}
                disableGutters={true}
                MenuListProps={{ "aria-labelledby": "user-avatar" }}
            >
                {!isLargeScreen && (
                    <>
                        <MenuItem
                            sx={{ pl: 4, pr: 4 }}
                            onClick={() => {
                                navigate("/subscription");
                                handleClose();
                            }}
                        >
                            <RupeeIcon
                                sx={{ mr: 1, width: "16px", height: "16px" }}
                            />{" "}
                            Pricing
                        </MenuItem>
                        {isPro2User && (
                            <MenuItem
                                sx={{ pl: 4, pr: 4 }}
                                onClick={() => {
                                    navigate("/auth-may-reset");
                                    handleClose();
                                }}
                            >
                                <LocalOfferIcon
                                    sx={{
                                        mr: 1,
                                        width: "16px",
                                        height: "16px",
                                    }}
                                />{" "}
                                May Reset
                            </MenuItem>
                        )}
                        <MenuItem
                            sx={{ pl: 4, pr: 4 }}
                            onClick={() => {
                                props.openToolsWalkthrough();
                                handleClose();
                            }}
                        >
                            <AutoStoriesOutlinedIcon
                                sx={{ mr: 1, width: "16px", height: "16px" }}
                            />{" "}
                            Tools Walkthrough
                        </MenuItem>
                        <MenuItem
                            sx={{ pl: 4, pr: 4 }}
                            onClick={() => {
                                openUserManualNew();
                                handleClose();
                            }}
                        >
                            <HelpIcon
                                sx={{ mr: 1, width: "16px", height: "16px" }}
                            />{" "}
                            User Manual
                        </MenuItem>
                        <MenuItem
                            sx={{ pl: 4, pr: 4 }}
                            onClick={() => {
                                openGlossary();
                                handleClose();
                            }}
                        >
                            <InfoIcon
                                sx={{ mr: 1, width: "16px", height: "16px" }}
                            />{" "}
                            Glossary
                        </MenuItem>
                        {!isDemoCompleted && (
                            <MenuItem
                                sx={{ pl: 4, pr: 4 }}
                                onClick={() => {
                                    openDemoConfirmPopup();
                                    handleClose();
                                }}
                            >
                                <DemoIcon
                                    sx={{
                                        mr: 1,
                                        width: "16px",
                                        height: "16px",
                                    }}
                                />{" "}
                                Elite Demo
                            </MenuItem>
                        )}
                    </>
                )}
                <MenuItem sx={{ pl: 4, pr: 4 }} onClick={openProfile}>
                <PersonOutlineIcon sx={{ mr: 1, width: "16px", height: "16px" }} />{" "}
                    Profile
                </MenuItem>
                <MenuItem sx={{ pl: 4, pr: 4 }} onClick={handleLogout}>
                <LogoutIcon sx={{ mr: 1, width: "16px", height: "16px" }} />{" "}
                    Logout
                </MenuItem>
            </Menu>

            <AppErrorPopup
                open={open}
                message={msg}
                severity={severity}
                onClose={handleClose}
                showCloseX
            />

            {showPopup && (
                <SubscriptionPopup
                    open={showPopup}
                    onClose={() => setShowPopup(false)}
                />
            )}
            {showProPopup && (
                <SubscriptionPopup
                    open={showProPopup}
                    data={subscriptionPopupData}
                    proMessage={true}
                    onClose={() => setShowProPopup(false)}
                />
            )}
            {showUserManualNewPopup && (
                <UserManualNewPopup
                    open={showUserManualNewPopup}
                    onClose={() => setShowUserManualNewPopup(false)}
                />
            )}
            {/* {props.openToolsWalkthrough && (
                <ToolsWalkthroughPopup
                    open={props.openToolsWalkthrough}
                    onClose={() => props.closeToolsWalkthrough}
                />
            )} */}
            {showFaqPopup && (
                <FAQPopup
                    open={showFaqPopup}
                    onClose={() => setShowFaqPopup(false)}
                />
            )}
            {showGlossaryPopup && (
                <GlossaryPopup
                    open={showGlossaryPopup}
                    onClose={() => setShowGlossaryPopup(false)}
                />
            )}
            {showBrokerPopup && (
                <BrokerPopup
                    open={showBrokerPopup}
                    onClose={() => setShowBrokerPopup(false)}
                />
            )}
            {showECoursePopup && (
                <EcoursePopup
                    open={showECoursePopup}
                    handleClose={() => setShowECoursePopup(false)}
                    onConfirm={handleConfirm}
                    ecourseAlreadyBought={isEcourseBought}
                />
            )}
            {showUpgradePopup && (
                <UpgradePopup
                    open={showUpgradePopup}
                    handleClose={() => setShowUpgradePopup(false)}
                    handleOpenSubscription={handleOpenSubscription}
                />
            )}
            {showDemoConfirmPopup && (
                <DemoConfirmationPopup
                    open={true}
                    demoType={demoType.demoType}
                    onClose={() => setShowDemoConfirmPopup(false)}
                    auth={auth}
                />
            )}
        </div>
    );
};

export default DashboardHeader;
